import { GroupQuestionResponseV1Enums } from "@pulse/pulse-rpcs/lib/respondent/groupQuestionResponseV1";
import { SubmittedResponseEnums } from "@pulse/pulse-rpcs/lib/respondent/submittedResponse";
import { Instance, types } from "mobx-state-tree";

export const MultiSelectResponseV1Model = types.model(
  "MultiSelectResponseV1Model",
  {
    multiSelectResponse: types.string,
  },
);

export const createMultiSelectResponseV1Model = (
  multiSelectResponse:
    | SubmittedResponseEnums.Response.Version1Enums.ResponseTypeV1.MultiSelect
    | GroupQuestionResponseV1Enums.ChildResponse.MultiSelect,
): Instance<typeof MultiSelectResponseV1Model> => {
  return MultiSelectResponseV1Model.create({
    multiSelectResponse: multiSelectResponse.answer,
  });
};
